const { defineMessages } = require('react-intl')

const messages = defineMessages({
  'dive-trips': {
    id: 'explore.empty.section.diveTrips',
    defaultMessage: 'No bookable dive trips here!',
  },
  courses: {
    id: 'explore.empty.section.courses',
    defaultMessage: 'No bookable courses here!',
  },
  snorkelling: {
    id: 'explore.empty.section.snorkelling',
    defaultMessage: 'No bookable snorkelling trips here!',
  },
  'social-events': {
    id: 'explore.empty.section.socialEvents',
    defaultMessage: 'No social events here!',
  },
  conservation: {
    id: 'explore.section.conservation',
    defaultMessage: 'No conservation events here!',
  },
  all: {
    id: 'explore.section.all',
    defaultMessage: 'No bookable activities here',
  },
})

export default messages
